import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { of } from "rxjs";

import { AppVersionService } from "../../../authentication/services/app-version.service";
import { AppDetailsApiActions } from "../actions/data/action-creators/app-details.actions";
import { SetupActions } from "../../../setup/state/actions/setup.actions";
import { SignInActions } from "../../../authentication/state/actions/sign-in.actions";
import { SignInWithUsernameActions } from "../../../authentication/state/actions/sign-in-with-username.actions";

@Injectable()
export class AppDetailsEffects {
	private actions$ = inject(Actions);
	private appVersionService = inject(AppVersionService);

	getLatestAppVersion$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(
				SetupActions.getLatestAppVersion,
				SignInActions.getLatestAppVersion,
				SignInWithUsernameActions.getLatestAppVersion,
			),
			exhaustMap(() =>
				this.appVersionService.getLatestAppVersion().pipe(
					map((version) => AppDetailsApiActions.getLatestAppVersionSuccess({ version })),
					catchError((error) => of(AppDetailsApiActions.getLatestAppVersionFailure({ error: error.message }))),
				),
			),
		);
	});
}
